import { createGlobalStyle } from 'styled-components'
import { Theme } from '.'

/* - INDEX -
 * SPACING
 * COLOR
 * TEXT
 */

const spacingDirectionKeys: Record<string, string[]> = {
  '': [],
  x: ['left', 'right'],
  y: ['bottom', 'top'],
  l: ['left'],
  r: ['right'],
  b: ['bottom'],
  t: ['top'],
}
const spacingKeys = {
  margin: { key: 'm', css: 'margin' },
  padding: { key: 'p', css: 'padding' },
}

function generateSpacingCSS(theme: Theme): string {
  const spacingSizes = Object.values(theme.spacing)

  const css = spacingSizes
    .map((size) => {
      return Object.values(spacingKeys)
        .map((spacingKey) => {
          return Object.entries(spacingDirectionKeys)
            .map(([directionKey, directions]) => {
              if (directions.length) {
                return `.${spacingKey.key}${directionKey}-${size}{
            ${directions.map((direction) => `${spacingKey.css}-${direction}: ${size}px;`).join('')}
          }`
              }
              return `.${spacingKey.key}${directionKey}-${size}{${spacingKey.css}: ${size}px;}`
            })
            .join('')
        })
        .join('')
    })
    .join('')
  // m-auto, m-0 ... mx-auto, mx-0 ...  p-auto, p-0
  return css
}

export default createGlobalStyle`
  // SPACING
  ${({ theme }) => generateSpacingCSS(theme)}

  // COLOR
  .primary {
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  .secondary {
    color: ${({ theme }) => theme.colors.secondary};
  }

  .background {
    background: ${({ theme }) => theme.colors.background};
  }

  .shadow {
    box-shadow: ${({ theme }) => theme.main.shadow};
  }
  .shadow-hover {
    box-shadow: ${({ theme }) => theme.main.shadowHover};
  }

  .opacity-50 {
    opacity: 0.5;
  }
  .opacity-40 {
    opacity: 0.4;
  }

  
  ${({ theme }) =>
    Object.entries(theme.colors).map(
      ([colorName, colorValue]) => `
    .ticket-${colorName}{
      border-left: 4px solid ${colorValue}
    }
  `,
    )}

  .cursor-pointer {
    cursor: pointer;
  }

  .hover-scale {
    transition: transform ${({ theme }) => theme.main.defaultAnimation};

    &:hover {
      transform: scale(1.05);
    }
  }

  .overflow-visible {
    overflow: visible;
  }

  .shaped {
    border-radius: ${({ theme }) => theme.main.borderRadius};
  }

  // SPACING
  .w-100 {
    width: 100%;
  }
  .h-100 {
    height: 100%;
  }

  .limited-content {
    max-width: ${({ theme }) => theme.main.contentMaxWidth}px;
  }

  .d-block {
    display: block;
  }
  .d-none {
    display: none;
  }
  .d-inline {
    display: inline;
  }
  .d-flex {
    display: flex;
  }
  .invisible {
    visibility: hidden;
  }

  .flex-1 {
    flex: 1;
  }
  .flex-2 {
    flex: 1;
  }
  .flex-grow-1 {
    flex-grow: 1;
  }

  .align-center {
    align-items: center;
  }
  .align-start {
    align-items: flex-start;
  }
  .align-end {
    align-items: flex-end;
  }

  .justify-center {
    justify-items: center;
  }
  .justify-start {
    justify-items: flex-start;
  }
  .justify-end {
    justify-items: flex-end;
  }

  // TEXT
  .bold {
    font-weight: 600 !important;
  }
  .thin {
    font-weight: 300;
  }
  .regular {
    font-weight: 400;
  }
  .light {
    color: ${({ theme }) => theme.colors.light} !important;
  }
  .dark {
    color: ${({ theme }) => theme.colors.dark};
  }
  .text-center {
    text-align: center;
  }
  .text-r {
    text-align: right;
  }
`
